module.exports = "/images/vendor/vue-paycard/src/elo.png?0e484c881e855d7f2c3e72b9966be20f";